// extracted by mini-css-extract-plugin
export default {"tip-container":"tip-container___FhNNp","tip":"tip___S57UF","btn":"btn___mkWxa","action-btn":"action-btn___b5fEY"};